module.exports = require("jss");


//////////////////
// WEBPACK FOOTER
// external "jss"
// module id = 2
// module chunks = 0